module.exports = __webpack_public_path__ + "media/images/form-mobile_fitting-6e083421e2fc1075208d1dbb16113c97.svg";